export const normalizeTrack = (track) => ({
    artistName: track.artistName || track.master_metadata_album_artist_name || '',
    trackName: track.trackName || track.master_metadata_track_name || '',
    msPlayed: track.msPlayed ?? track.ms_played ?? 0,
});

export function getRewindStats(data = []) {
    const tracks = new Map();
    const artists = new Map();
    let totalMs = 0;
    let events = 0;
    let skips = 0;

    data.forEach(raw => {
        if (!raw || typeof raw !== 'object') return;
        const {trackName, artistName, msPlayed} = normalizeTrack(raw);
        if (typeof trackName !== 'string' || !trackName.trim() ||
            typeof artistName !== 'string' || !Number.isFinite(raw.msPlayed ?? raw.ms_played) ||
            !Number.isFinite(msPlayed) || msPlayed < 0) return;

        const name = trackName.trim();
        const artist = artistName.trim();
        const key = JSON.stringify([artist, name]);
        const track = tracks.get(key) || {name, artist, plays: 0};
        track.plays += 1;
        tracks.set(key, track);
        if (artist) artists.set(artist, (artists.get(artist) || 0) + 1);
        totalMs += msPlayed;
        events += 1;
        if (msPlayed < 30000) skips += 1;
    });

    const topTrack = [...tracks.values()].sort((a, b) => b.plays - a.plays)[0];
    const topArtist = [...artists.entries()].sort((a, b) => b[1] - a[1])[0];

    return {
        events,
        excluded: data.length - events,
        minutes: Math.round(totalMs / 60000),
        days: (totalMs / 86400000).toFixed(1),
        skips,
        skipRate: events ? Math.round(skips / events * 100) : 0,
        uniqueTracks: tracks.size,
        uniqueArtists: artists.size,
        topTrack,
        topArtist: topArtist ? {name: topArtist[0], plays: topArtist[1]} : null,
    };
}
